import * as _ from 'underscore'
import { ITemplate as ITemplate_MvcStudio, Templates as Templates_MvcStudio, Template as Template_MvcStudio } from 'mappMvcStudio/compile'

export interface ITemplate extends ITemplate_MvcStudio {
    mapps_header: string;
    mapps_launchNotification: string;
    mapps_mobileApp: string;
    mapps_table: string;
    mapps_tile: string;
    mapps_tileGrid: string;
};
export var Templates: ITemplate = _.extend({}, Templates_MvcStudio, {
    mapps_header: 'mapps_header',
    mapps_launchNotification: 'mapps_launchNotification',
    mapps_mobileApp: 'mapps_mobileApp',
    mapps_table: 'mapps_table',
    mapps_tile: 'mapps_tile',
    mapps_tileGrid: 'mapps_tileGrid'
});
export var Template = _.extend({}, Template_MvcStudio, {
    [Templates.mapps_header]: `<div class="section-table-header mapps" style="height: 46px; overflow: hidden;">
    <div class="actions switch">
        <!-- ko with: templateSwitch -->
        <div data-bind="template: { name: template, data: $data }" style="height: 46px;"></div>
        <!-- /ko -->
    </div>
    <div data-bind="click: clickDesktopFilter" class="widget-wrapper active" style="cursor: pointer; padding: 5px; padding-left: 10px; height: 46px; position: relative; top: 3px;">
        <div class="widget" style="display: inline; display: flex;">
            <label style="cursor: pointer; margin-right:10px;color: var(--bg-55); font-weight:bold; text-transform: capitalize; line-height: 32px;" data-bind="text: mapp.Localization.Studio.Desktop.Desktop.toLowerCase()"></label>
            <div class="checkbox" data-bind="css: {'hehe-icons-check': desktopFilterChecked}"></div>
        </div>
    </div>
    <div data-bind="click: clickBrowserFilter" class="widget-wrapper active" style="cursor: pointer; padding: 5px; padding-left: 10px; height: 46px; position: relative; top: 3px;">
        <div class="widget" style="display: inline; display: flex;">
            <label style="cursor: pointer; margin-right:10px;color: var(--bg-55); font-weight:bold; text-transform: capitalize; line-height: 32px;" data-bind="text: mapp.Localization.Studio.Browser.toLowerCase()"></label>
            <div class="checkbox" data-bind="css: {'hehe-icons-check': browserFilterChecked}"></div>
        </div>
    </div>
    <div data-bind="click: clickMobileFilter" class="widget-wrapper active" style="cursor: pointer; padding: 5px; padding-left: 10px; height: 46px; position: relative; top: 3px;">
        <div class="widget" style="display: inline; display: flex;">
            <label style="cursor: pointer; margin-right:10px;color: var(--bg-55); font-weight:bold; text-transform: capitalize; line-height: 32px;" data-bind="text: mapp.Localization.Studio.Mobile.toLowerCase()"></label>
            <div class="checkbox" data-bind="css: {'hehe-icons-check': mobileFilterChecked}"></div>
        </div>
    </div>
    <div class="widget" data-bind="css: {'active': table.isSearchActive}, visible: table.isSearchVisible" style="display: flex; flex-direction: row; height: 46px;">        
        <input class="list-header-input" type="text" data-bind="attr: {placeholder: mapp.Localization.Search}, textInput: table.searchInput" style="height: 26px;" />
    </div>
</div>`,
    [Templates.mapps_launchNotification]: `<div class="icon"></div>
<div class="message">
    <div class="title" data-bind="text: mapp.Localization.Errors.MissingHexagonAppLauncher.Title, attr: {title: mapp.Localization.Errors.MissingHexagonAppLauncher.Title}"></div>
    <div class="text">
        <span data-bind="text: mapp.Localization.Errors.MissingHexagonAppLauncher.HintStart, attr: {title: mapp.Localization.Errors.MissingHexagonAppLauncher.HintStart.concat(' ',mapp.Localization.Errors.MissingHexagonAppLauncher.HexagonAppLauncher, ' ', mapp.Localization.Errors.MissingHexagonAppLauncher.HintEnd)}"></span>
        <a data-bind="click: okClick, text: mapp.Localization.Errors.MissingHexagonAppLauncher.HexagonAppLauncher, attr: {title: mapp.Localization.Download.concat(' ', mapp.Localization.Errors.MissingHexagonAppLauncher.HexagonAppLauncher)}" href="../AppLauncher/AppLauncher.exe" target="_blank" style="cursor: pointer;text-decoration: underline;font-weight:bold"></a>
        <span data-bind="text: mapp.Localization.Errors.MissingHexagonAppLauncher.HintEnd, attr: {title: mapp.Localization.Errors.MissingHexagonAppLauncher.HintStart.concat(' ',mapp.Localization.Errors.MissingHexagonAppLauncher.HexagonAppLauncher, ' ', mapp.Localization.Errors.MissingHexagonAppLauncher.HintEnd)}"></span>
    </div>
</div>
<a class="close action hide-action hehe-icons-cancel" data-bind="click: close.bind($data)"></a>`,
    [Templates.mapps_mobileApp]: `<canvas id="mapp-mobile-app" data-bind="element: qrCode"></canvas>
<div class="server-info">
    <div>
        <div>title</div>
        <div data-bind="text: serverInfo.name"></div>
    </div>
    <div>
        <div>tenant</div>
        <div data-bind="text: serverInfo.title"></div>
    </div>
    <div>
        <div>url</div>
        <div data-bind="text: serverInfo.baseUrl"></div>
    </div>
</div>`,
    [Templates.mapps_table]: `<div class="mapp-mapps-section-wrapper">
    <!-- ko template: { name: mapp.Templates.mapps_header, data: $data }-->
    <!-- /ko -->
    <div class="table-wrapper no-gutter mapp-cell-1-1" data-bind="with: table">
        <table class="base-table">
            <thead data-bind="template: { name: mapp.Templates.table_header, data: $data }"></thead>
            <tbody data-bind="template: { name: mapp.Templates.table_body, foreach: view, as: 'item' }"></tbody>
        </table>
        <!-- ko template: { name: mapp.Templates.table_empty, data: $data }-->
        <!-- /ko -->
        <!-- ko template: { name: mapp.Templates.table_pager, data: $data }-->
        <!-- /ko -->
    </div>
</div>
`,
    [Templates.mapps_tile]: `<div class="mapp-tile" data-bind="click: $parent.clickLaunch, style: {width: $parent.columnWidth}" title="Launch">
    <div class="mapp-tile-inner">
        <figure data-bind="attr: { class: bgClass }">
            <!-- ko if: image -->
            <div class="image"  data-bind="style: { backgroundImage: 'url(' + image + ')' }"></div>
            <!-- /ko -->
            <figcaption>
                <span class="name" data-bind="text: name"></span><span class="app-type" data-bind="text: appTypeDisplay"></span>
            </figcaption>
        </figure>
        <div class="action-bar">
            <a class="mapp-tile-action hehe-icons-launch">
            </a>
        </div>
        <div data-bind="css: iconClass">
        </div>
    </div>
</div>`,
    [Templates.mapps_tileGrid]: `<div class="mapp-mapps-section-wrapper">
    <!-- ko template: { name: mapp.Templates.mapps_header, data: $data }-->
    <!-- /ko -->
    <div class="table-wrapper no-gutter mapp-cell-1-1">
        <table class="base-table">
            <thead data-bind="template: { name: mapp.Templates.table_header, data: table }"></thead>
        </table>
        <!-- ko template: { name: mapp.Templates.table_empty, data: table }-->
        <!-- /ko -->
    </div>
    <div class="mapp-mapps-wrapper tile-grid shadow-off" data-bind="template: { name: mapp.Templates.mapps_tile, foreach: table.dataSource.view }">
    </div>
    <!-- ko template: { name: mapp.Templates.table_pager, data: table }-->
    <!-- /ko -->
</div>`
});